import React from 'react';
import X from './img/X.svg';
import Instagram from './img/Instagram.svg';
import Linkedin from './img/Linkedin.svg';
import Youtube from './img/Youtube.svg';
import Facebook from './img/Facebook.svg';
import Telefonoanalogo from './img/Telefonoanalogo.svg';

const Column = ({ title, items, links }) => (
  <div style={{ display: 'flex', width: '100%', alignItems: 'center', flexDirection: 'column', gap: '14px' }}>
    <span
      style={{ color: '#000000', fontSize: '16px', fontWeight: '600', fontFamily: 'Sura Sans', marginTop: '22px' }}
    >
      {title}
    </span>
    <div style={{ display: 'flex', width: '100%', alignItems: 'center', flexDirection: 'column', gap: '5px' }}>
      {items.map((item, index) =>
        links && links[index] ? (
          <a
            key={index}
            href={links[index]}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#888B8D',
              fontSize: '14px',
              fontWeight: '400',
              fontFamily: 'Sura Sans',
              textDecoration: 'none'
            }}
          >
            {item}
          </a>
        ) : (
          <span key={index} style={{ color: '#888B8D', fontSize: '14px', fontWeight: '400', fontFamily: 'Sura Sans' }}>
            {item}
          </span>
        )
      )}
    </div>
  </div>
);

const FooterMobile = () => (
  <div
    style={{
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      background: '#FFFFFF',
      flexDirection: 'column',
      padding: '20px 0 40px',
      height: '100%',
      boxShadow: '0px 0px 15px #00000029'
    }}
  >
    <Column
      title="Seguros SURA México"
      items={['Acerca de SURA', 'Grupo SURA', 'SURA Asset Management', 'Suramericana', 'Fundación SURA']}
      links={[
        null,
        'https://www.gruposura.com',
        'https://invierteyahorra.suramexico.com/suramexico/',
        'https://www.suramericana.com/index.html',
        'https://www.fundacionsura.com/'
      ]}
    />
    <Column
      title="Oficinas"
      items={['CDMX']}
      links={['https://www.segurossura.com.mx/oficinas/corporativo/']}
    />
    <Column
      title="Servicios"
      items={[
        'Condiciones Generales',
        'Básicos estandarizados',
        'Red Médica',
        'Tabulador Quirúrgico',
        'GeoSURA',
        'Talento Humano'
      ]}
      links={[
        'https://www.segurossura.com.mx/condiciones-generales/',
        'https://www.segurossura.com.mx/personas/basicos-estandarizados/',
        'https://www.segurossura.com.mx/wp-content/uploads/2024/05/Red-Medica-052024.xlsx',
        'https://www.segurossura.com.mx/tabulador-quirurgico/',
        'https://geo.sura.com/principal/',
        'https://www.segurossura.com.mx/talento-humano/'
      ]}
    />
    <Column
      title="Legales"
      items={[
        'Aviso de privacidad',
        'Atención a usuarios',
        'Seguridad informática',
        'Política de identificación y conocimiento del cliente',
        'Línea ética'
      ]}
      links={[
        'https://qa-portal.segurossura.com.mx/legales/aviso-de-privacidad/',
        'https://www.segurossura.com.mx/legales/unidad-especializada-de-atencion-a-usuarios-une/',
        'https://www.segurossura.com.mx/legales/seguridad-informatica/',
        'https://www.segurossura.com.mx/legales/politica-de-identificacion-y-conocimiento-del-cliente/',
        'https://www.segurossura.com.mx/legales/linea_etica/'
      ]}
    />
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        width: '250px',
        justifyContent: 'center'
      }}
    >
      <span
        style={{ color: '#000000', fontSize: '14px', fontWeight: 600, fontFamily: 'Sura Sans', textAlign: 'center', paddingTop: '22px' }}
      >
        Síguenos
      </span>
      <div style={{ display: 'flex', justifyContent: 'space-between', height: 'auto', padding: '10px 0 22px' }}>
        <a href="https://www.facebook.com/SegurosSURAMexico/" target="_blank" rel="noopener noreferrer">
          <img src={Facebook} alt="Facebook" />
        </a>
        <a href="https://www.instagram.com/segurossuramx/" target="_blank" rel="noopener noreferrer">
          <img src={Instagram} alt="Instagram" />
        </a>
        <a
          href="https://www.linkedin.com/company/seguros-sura/?viewAsMember=true"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={Linkedin} alt="LinkedIn" />
        </a>
      </div>
      <span
        style={{ color: '#000000', fontSize: '14px', fontWeight: 600, fontFamily: 'Sura Sans', textAlign: 'center' }}
      >
        Línea de atención
      </span>
      <a href="tel:8007237900">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            width: '230px',
            height: '35px',
            background: '#2D6DF6',
            borderRadius: '28px',
            marginTop: '10px'
          }}
        >
          <img
            src={Telefonoanalogo}
            style={{
              maxWidth: '20px',
              maxHeight: '19px'
            }}
            alt="Teléfono"
          />
          <span style={{ color: '#FFFFFF', fontSize: '16px', fontWeight: 500, fontFamily: 'Sura Sans' }}>
            800 723 7900
          </span>
        </div>
      </a>
      <a href="tel:5557237999">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            width: '230px',
            height: '35px',
            background: '#2D6DF6',
            borderRadius: '28px',
            marginTop: '10px'
          }}
        >
          <img
            src={Telefonoanalogo}
            style={{
              maxWidth: '20px',
              maxHeight: '19px'
            }}
            alt="Teléfono"
          />
          <span style={{ color: '#FFFFFF', fontSize: '16px', fontWeight: 500, fontFamily: 'Sura Sans' }}>
            555 723 7999
          </span>
        </div>
      </a>
      <a href="https://qa-portal.segurossura.com.mx/contacto/">
        <div style={{ marginTop: '15px' }}>
          <span
            style={{
              color: '#888B8D',
              fontSize: '14px',
              marginTop: '10px',
              fontFamily: 'Sura Sans',
              textAlign: 'center'
            }}
          >
            Contáctanos por mail
          </span>
        </div>
      </a>
    </div>

    <span style={{ color: '#000000', fontSize: '14px', fontWeight: '600', fontFamily: 'Sura Sans', marginTop: '22px' }}>
      © 2016 SURA. Todos los derechos reservados.
    </span>
    <a
      href="https://www.segurossura.com.mx/legales/aviso-de-privacidad/"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: '#0033A0', fontSize: '14px', fontFamily: 'Sura Sans', textDecoration: 'none', marginTop: '22px' }}
    >
      Aviso de privacidad integral
    </a>
    <a
      href="https://www.segurossura.com.mx/wp-content/uploads/2022/06/Aviso-pago-recurrente-seguros-sura.pdf"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: '#0033A0', fontSize: '14px', fontFamily: 'Sura Sans', textDecoration: 'none', marginTop: '22px' }}
    >
      Aviso de pago recurrente
    </a>
  </div>
);

export default FooterMobile;


// WEBPACK FOOTER //
// ./src/containers/agent/Tabs/Payments/FooterMobile.js